import { createSlice } from "@reduxjs/toolkit";
import { getState } from "@bd-stores/store";

/**
 * @type {BD_StoreGameProgress}
 */
const initialState = {
    players: [],
    finalTeamAnswers: {},
    teamAnswers: {},
    roomStatus: {},
    totalRoomCompleted: 0,
    allRoomCompleted: false,
    isFinished: false,
    isMiddleState: false,
    hintUsed: {},
};

const gameProgressSlice = createSlice({
    name: "gameProgress",
    initialState,
    reducers: {
        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['players']>} action
         */
        setPlayers: (state, action) => ({
            ...state,
            players: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['finalTeamAnswers']>} action
         */
        setFinalTeamAnswers: (state, action) => ({
            ...state,
            finalTeamAnswers: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['teamAnswers']>} action
         */
        setTeamAnswers: (state, action) => ({
            ...state,
            teamAnswers: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['roomStatus']>} action
         */
        setRoomStatus: (state, action) => ({
            ...state,
            roomStatus: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['hintUsed']>} action
         */
        setHintUsed: (state, action) => ({
            ...state,
            hintUsed: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['totalRoomCompleted']>} action
         */
        setTotalRoomCompleted: (state, action) => ({
            ...state,
            totalRoomCompleted: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['allRoomCompleted']>} action
         */
        setAllRoomCompleted: (state, action) => ({
            ...state,
            allRoomCompleted: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['isFinished']>} action
         */
        setFinished: (state, action) => ({
            ...state,
            isFinished: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameProgress['isMiddleState']>} action
         */
        setIsMiddleState: (state, action) => ({
            ...state,
            isMiddleState: action.payload,
        }),
    },
});

export const getAllRoomStatus = () => {
    const roomStatus = getState().gameProgress.roomStatus;
    return roomStatus;
};

export const getRoomStatus = (roomId) => {
    const roomStatus = getState().gameProgress.roomStatus;
    return roomStatus?.[roomId] || "is-status-open";
};

export const getFinalTeamAnswers = (roomId) => {
    const finalTeamAnswers = getState().gameProgress.finalTeamAnswers;
    return finalTeamAnswers?.[roomId] || false;
};

export const getTeamAnswers = (roomId) => {
    const teamAnswers = getState().gameProgress.teamAnswers;
    return teamAnswers?.[roomId] || false;
};

export const getPlayers = () => {
    const players = getState().gameProgress.players;
    return players ?? [];
};

export const getHintUsed = (roomId) => {
    const hintUsed = getState().gameProgress.hintUsed;
    return hintUsed?.[roomId] || false;
};

export const getUserFromId = (userId) => {
    const players = getState().gameProgress.players;
    const user = players.find((p) => p.userId === userId);
    return user;
};

export const getTotalRoomCompleted = () => {
    const totalRoomCompleted = getState().gameProgress.totalRoomCompleted;
    return totalRoomCompleted;
};

export const {
    setPlayers,
    setTeamAnswers,
    setFinalTeamAnswers,
    setRoomStatus,
    setHintUsed,
    setTotalRoomCompleted,
    setAllRoomCompleted,
    setFinished,
    setIsMiddleState,
} = gameProgressSlice.actions;
export const gameProgress = gameProgressSlice.reducer;
